var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0799 0.180044H2.14993C1.05993 0.180044 0.179932 1.06004 0.179932 2.15004V6.80004C0.179932 7.89004 1.06993 8.78004 2.15993 8.78004H9.25993L11.5399 10.77V8.78004H13.0899C14.1799 8.78004 15.0699 7.89004 15.0699 6.80004V2.15004C15.0699 1.06004 14.1799 0.170044 13.0899 0.170044L13.0799 0.180044Z",
    stroke: "#565757",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.06011 5.29001C4.44671 5.29001 4.76011 4.97661 4.76011 4.59001C4.76011 4.20342 4.44671 3.89001 4.06011 3.89001C3.67351 3.89001 3.36011 4.20342 3.36011 4.59001C3.36011 4.97661 3.67351 5.29001 4.06011 5.29001Z",
    fill: "#565757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6502 5.29001C8.03679 5.29001 8.3502 4.97661 8.3502 4.59001C8.3502 4.20342 8.03679 3.89001 7.6502 3.89001C7.2636 3.89001 6.9502 4.20342 6.9502 4.59001C6.9502 4.97661 7.2636 5.29001 7.6502 5.29001Z",
    fill: "#565757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.23 5.29001C11.6166 5.29001 11.93 4.97661 11.93 4.59001C11.93 4.20342 11.6166 3.89001 11.23 3.89001C10.8434 3.89001 10.53 4.20342 10.53 4.59001C10.53 4.97661 10.8434 5.29001 11.23 5.29001Z",
    fill: "#565757"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.23,
    height: 11.15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewImage);
export default __webpack_public_path__ + "static/media/reviewImage.85b84e75e3d0fa6718087cb42300f129.svg";
export { ForwardRef as ReactComponent };